import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-report-template-import-confirm',
    templateUrl: './import-new-template-dialog.component.html',
    styleUrls: ['./import-new-template-dialog.component.scss'],
    standalone: false
})

export class ImportNewTemplateDialogComponent {

  constructor(
    private dialogRef: MatDialogRef<ImportNewTemplateDialogComponent, { result: boolean }>,
    @Inject(MAT_DIALOG_DATA) public data: any) {
  }

  confirm(): void {
    this.dialogRef.close({ result: true });
  }
}
